import { QuestionIcon } from '@phosphor-icons/react';

import Switch from '@atoms/new/switch';
import Tooltip from '@components/Presentation/atoms/Tooltip';

const SettingSwitch = ({ label, tooltipContent, settingKey, settingValue, onChangeHandler, labelCss = '' }) => (
  <div className="flex">
    <div className={`flex flex-1 text-sm flex-nowrap text-default-900 ${labelCss}`}>
      {label} &nbsp;
      {tooltipContent && <Tooltip content={tooltipContent}>
        <QuestionIcon size={20} className='text-default-400' />
      </Tooltip>}
    </div>
    <Switch
      disableAnimation
      onValueChange={(e) =>
        onChangeHandler(settingKey, !settingValue)
      }
      isSelected={!!settingValue}
    />
  </div>
);

export default SettingSwitch;
